import axios from 'axios'
import Common from '@/scripts/Common.js';

//API per repertori
function getUrlNovita(param) {
  var url = '/SCTProfessional/repertcarto/callauth/json/get_rows_novita';
  /*
  if (process.env.NODE_ENV === 'development') {
    url = '/SCTProfessional/repertcarto/call/json/get_rows_novita';
    url = 'http://localhost:8000' + url;
  }*/
  url = url + '?param=' + param;
  return url;
}

function getUrlDaAggiornare(param) {
  var url = '/SCTProfessional/repertcarto/callauth/json/get_rows_daaggiornare';
  /*
  if (process.env.NODE_ENV === 'development') {
    url = '/SCTProfessional/repertcarto/call/json/get_rows_daaggiornare';
    url = 'http://localhost:8000' + url;
  }*/
  url = url + '?param=' + param;
  return url;
}

function getUrlScaricati(param) {
  var url = '/SCTProfessional/repertcarto/callauth/json/get_rows_scaricati_update';
  url = url + '?param=' + param;
  return url;
}

function getUrlDispComplessiva(param) {
  var url = '/SCTProfessional/repertcarto/callauth/json/get_rows_dascaricare';
  url = url + '?param=' + param;
  return url;
}

function getUrlAllRepertori(param) {
  var url = '/SCTProfessional/repertcarto/call/json/get_rows_alldascaricare';
  url = url + '?param=' + param;
  return url;
}

function getUrlRepMultiDownload(codfis, serv, liv) {
  let sep=''
  let url = '/SCTProfessional/repertcarto/call/json/get_rows_rep_multidownload';
  url = url + sep + '?codfis=' + codfis;
  if (serv !== '') {
    sep = '&'
    url = url + sep +'serv=' + serv;
  }
  if (liv !== '') {
    sep = '&'
    url = url + sep +'liv=' + liv;
  }
  // console.log('getUrlRepMultiDownload',url)
  // url=url.replace(/\|/g, '_PIPE_');
  return url;
}

function getUrlAllCategorie() {
  var url = '/SCTProfessional/repertcarto/call/json/get_rows_table_dbbo';
  // url = url + '?param=' + param;
  return url;
}

function getUrlApriDocFile(param) {
  var url = '/SCTProfessional/repertcarto/apriDocFile';
  /*
  if (process.env.NODE_ENV === 'development') {
    url = '/SCTProfessional/repertcarto/apriDocFile';
    url = 'http://localhost:8000' + url;
  }*/
  url = url + '?param=' + param;
  return url;
}

function get_img_sctoutil_libre() {
  return require('@/images/LibreH.png')
}

function get_img_sctoutil_pro() {
  return require('@/images/ProH.png')
}

function get_img_metadato_link() {
  return require('@/images/MetadatoLink.png')
}

function get_img_nonautorizzato() {
  return require('@/images/NonAutorizzato.png')
}

function get_img_noncompatibile() {
  return require('@/images/NonCompatibile.png')
}

export default {
  formatBoolRiservato(rowObj) {
    return Common.formatBool(rowObj.riservato)
  },
  formatSCTOutilAllRepert(rowObj) {
    if (rowObj.riservato) {
      // return 'PRO'
      return '<img src="' + get_img_sctoutil_pro() + '" class = "img-fluid" >'
    }
    if (!rowObj.riservato) {
      // return 'Libre'
      return '<img src="' + get_img_sctoutil_libre() + '" class = "img-fluid" >'
    }
    return ''
  },
  formatSCTOutil(rowObj) {
    if (rowObj.download_pubblico && !rowObj.download_professionisti) {
      /*return '<a target="_blank" href="'+rowObj.url_download_pubblico+'" class="urlmail">Seleziona per download da piattaforma esterna&nbsp;<i class="fas fa-external-link-alt"></i></a>';*/
      return '<a title="Seleziona per download da piattaforma esterna" target="_blank" href="'+rowObj.url_download_pubblico+'" class="link-box">DA ALTRA PIATTAFORMA</a>';
    }
    if (!rowObj.download_pubblico && rowObj.geotipo=='FeatureClass' && !rowObj.download_professionisti) {
      if (rowObj.riservato) {
        // return 'Dato riservato'
        return 'Download non disponibile'
      }
      else {
        return 'Download non disponibile'
      }
    }
    if (!rowObj.download_pubblico && rowObj.geotipo!='FeatureClass' && !rowObj.download_professionisti) {
      // return 'Formato non compatibile'
      return 'Download non disponibile'
    }
    if (rowObj.riservato && rowObj.download_professionisti) {
      // return 'PRO'
      return '<img src="' + get_img_sctoutil_pro() + '" class = "img-fluid" >'
    }
    if (!rowObj.riservato && rowObj.download_professionisti) {
      // return 'Libre'
      return '<img src="' + get_img_sctoutil_libre() + '" class = "img-fluid" >'
    }
    return ''
  },
  apriDocFile(param) {
    window.open(getUrlApriDocFile(param), '_blank')
  },
  getRepertNovita(param) {
    return axios
      .get(getUrlNovita(param))
      .then(response => {
        return response.data;
      })
  },
  getRepertDaAggiornare(param) {
    return axios
      .get(getUrlDaAggiornare(param))
      .then(response => {
        return response.data;
      })
  },
  getRepertScaricati(param) {
    return axios
      .get(getUrlScaricati(param))
      .then(response => {
        return response.data;
      })
  },
  getRepertDispComplessiva(param) {
    return axios
      .get(getUrlDispComplessiva(param))
      .then(response => {
        return response.data;
      })
  },
  getRepertAllRepertori(param) {
    return axios
      .get(getUrlAllRepertori(param))
      .then(response => {
        return response.data;
      })
  },
  async getRepertMultiDownload(param,serv,liv) {
    return axios
      .get(getUrlRepMultiDownload(param,serv,liv))
      .then(response => {
        return response.data;
      })
  },
  async getAllCategorie(data) {
    return axios
      .post(getUrlAllCategorie(), data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(response => {
        return response.data;
      })
  },
  //definizione colonne e righe per vue-good-table
  getColsRepertScaricati(obj) {
    return [{
        field: 'id',
        label: 'ID',
        type: 'number',
        width: 30,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'objectid',
        label: 'objectid',
        type: 'number',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'ordine',
        label: 'ordine',
        type: 'number',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'tipo_record',
        label: 'tipo_record',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'categoria',
        label: 'Categoria',
        width: "15%",
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'denominazione',
        label: 'Dato',
        width: "50%",
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'datapub',
        label: 'Pubblicato o aggiornato',
        width: "15%",
        hidden: false,
        sortFn: Common.dataStringSort,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'data_scarico',
        label: 'Scaricato',
        width: "15%",
        sortFn: Common.dataStringSort,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'chiave_layer',
        label: 'Dato',
        width: 100,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'metadato',
        label: 'metadato',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'datatipo',
        label: 'datatipo',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'isnull_note',
        label: 'isnull_note',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'note',
        label: 'note',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'htmlurl_note',
        label: 'Condizioni dello strato',
        html: true,
        hidden: false,
        width: "15%",
        sortable: false,
        tdClass: obj.tdClassRepertScaricati
        //dataClass: 'center aligned'
        //formatFn: this.NoteFormatterScaricati
      },
      {
        field: 'isnull_metadato',
        label: 'isnull_metadato',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertScaricati
      },
      {
        field: 'htmlurl_metadato',
        label: 'Metadato',
        html: true,
        hidden: false,
        sortable: false,
        width: "15%",
        tdClass: obj.tdClassRepertScaricati
        //formatFn: this.MetadatoFormatter
      },
      {
        field: 'htmlurl_download',
        label: 'Download',
        width: "15%",
        html: true,
        hidden: false,
        sortable: false,
        tdClass: obj.tdClassRepertScaricati
      },
    ];
  },
  getColsRepertNovita(obj) {
    return [{
        field: 'id',
        label: 'ID',
        type: 'number',
        width: 30,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'objectid',
        label: 'objectid',
        type: 'number',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'ordine',
        label: 'ordine',
        type: 'number',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'tipo_record',
        label: 'tipo_record',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'datapub',
        label: 'Pubblicato o aggiornato',
        width: 50,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'categoria',
        label: 'Categoria',
        width: "15%",
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'denominazione',
        label: 'Dato',
        width: "50%",
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'chiave_layer',
        label: 'Dato',
        width: 100,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'metadato',
        label: 'metadato',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'datatipo',
        label: 'datatipo',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'isnull_note',
        label: 'isnull_note',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'note',
        label: 'note',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'htmlurl_note',
        label: 'Condizioni dello strato',
        hidden: false,
        html: true,
        width: "15%",
        sortable: false,
        tdClass: obj.tdClassRepertNovita
        //dataClass: 'center aligned'
        //formatFn: this.NoteFormatterScaricati
      },
      {
        field: 'isnull_metadato',
        label: 'isnull_metadato',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertNovita

      },
      {
        field: 'htmlurl_metadato',
        label: 'Metadato',
        hidden: false,
        html: true,
        width: "15%",
        sortable: false,
        tdClass: obj.tdClassRepertNovita
        //formatFn: this.MetadatoFormatter
      },
      {
        field: 'data_scarico',
        label: 'Ultimo download',
        width: "15%",
        hidden: true,
        tdClass: obj.tdClassRepertNovita
      },
      {
        field: 'htmlurl_download',
        label: 'Download',
        width: "15%",
        html: true,
        hidden: false,
        sortable: false,
        tdClass: obj.tdClassRepertNovita
      },
    ];
  },
  getColsRepertDaAggiornare(obj) {
    return [{
        field: 'id',
        label: 'ID',
        type: 'number',
        width: 30,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'objectid',
        label: 'objectid',
        type: 'number',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'ordine',
        label: 'ordine',
        type: 'number',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'tipo_record',
        label: 'tipo_record',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'datapub',
        label: 'Pubblicato o aggiornato',
        width: "15%",
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'categoria',
        label: 'Categoria',
        width: "15%",
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'denominazione',
        label: 'Dato',
        width: "50%",
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'chiave_layer',
        label: 'Dato',
        width: 100,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'metadato',
        label: 'metadato',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'datatipo',
        label: 'datatipo',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'isnull_note',
        label: 'isnull_note',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'note',
        label: 'note',
        width: 75,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'htmlurl_note',
        label: 'Condizioni dello strato',
        hidden: false,
        html: true,
        width: "15%",
        sortable: false,
        tdClass: obj.tdClassRepertDaAggiornare
        //dataClass: 'center aligned'
        //formatFn: this.NoteFormatterScaricati
      },
      {
        field: 'isnull_metadato',
        label: 'isnull_metadato',
        width: 50,
        hidden: true,
        tdClass: obj.tdClassRepertDaAggiornare

      },
      {
        field: 'htmlurl_metadato',
        label: 'Metadato',
        hidden: false,
        html: true,
        width: "15%",
        sortable: false,
        tdClass: obj.tdClassRepertDaAggiornare
        //formatFn: this.MetadatoFormatter
      },
      {
        field: 'htmlurl_download',
        label: 'Download',
        width: "15%",
        html: true,
        hidden: false,
        sortable: false,
        tdClass: obj.tdClassRepertDaAggiornare
      },
      {
        field: 'data_scarico',
        label: 'Ultimo download',
        width: "15%",
        tdClass: obj.tdClassRepertDaAggiornare
      },
    ];
  },
  
  getColsRepertDispComplessiva(obj) {
     var ishiddensctoutil = false
    return [
      {
        field: 'selected', // This is the field custom for selection checkbox
        label: ' ',
        width: "5%",
        hidden: false,
        sortable: false
      },
      {
        field: 'id',
        label: 'ID',
        type: 'number',
        width: 30,
        hidden: true
      },
      {
        field: 'objectid',
        label: 'objectid',
        type: 'number',
        width: 50,
        hidden: true
      },
      {
        field: 'ordine',
        label: 'ordine',
        type: 'number',
        width: 50,
        hidden: true
      },
      {
        field: 'tipo_record',
        label: 'tipo_record',
        width: 50,
        hidden: true
      },
      {
        field: 'categoria',
        label: 'Combobox categoria',
        width: "30%",
        hidden: true
      },
      {
        field: 'categoria_fe',
        label: 'Cartografia',
        width: "30%",
      },
      {
        field: 'denominazione',
        label: 'Dato',
        width: "30%"
      },
      {
        field: 'chiave_layer',
        label: 'chiave_layer',
        width: 100,
        hidden: true
      },
      {
        field: 'metadato',
        label: 'metadato',
        width: 75,
        hidden: true
      },
      {
        field: 'datatipo',
        label: 'datatipo',
        width: 75,
        hidden: true
      },
      {
        field: 'isnull_note',
        label: 'isnull_note',
        width: 75,
        hidden: true
      },
      {
        field: 'note',
        label: 'note',
        width: 75,
        hidden: true
      },
      {
        field: 'datapub',
        label: 'Pubblicato o aggiornato',
        width: "7%",
        sortFn: Common.dataStringSort,
        tdClass: obj.tdClassRepertDispComplessiva
      },
      {
        field: 'data_scarico',
        label: 'Scaricato',
        width: "7%",
        hidden: false,
        sortFn: Common.dataStringSort,
        tdClass: obj.tdClassRepertDispComplessiva
      },
      {
        field: 'htmlurl_note',
        label: 'Condizioni dello strato',
        hidden: false,
        html: true,
        width: "5%",
        sortable: false,
        tdClass: obj.tdClassRepertDispComplessiva
        //dataClass: 'center aligned'
        //formatFn: this.NoteFormatterScaricati
      },
      {
        field: 'isnull_metadato',
        label: 'isnull_metadato',
        width: 50,
        hidden: true
      },
      {
        field: 'htmlurl_metadato',
        label: 'Metadato',
        hidden: false,
        html: true,
        width: "5%",
        sortable: false,
        tdClass: obj.tdClassRepertDispComplessiva
        //formatFn: this.MetadatoFormatter
      },
      {
        field: 'htmlurl_download',
        label: 'Download',
        // width: "10%",
        html: true,
        hidden: true,
        sortable: false,
        tdClass: obj.tdClassRepertDispComplessiva
      },
      {
        field: this.formatSCTOutil,
        label: 'Download',
        image: 'fas fa-info-circle',
        tooltip: 'Dati disponibili in coordinate ED50 / UTM 32N e RDN2008 / UTM 32N',
        html: true,
        width: "11%",
        hidden: ishiddensctoutil
      },
      ];
  },
  getColsRepertAllRepertori(url_libre, url_pro) {
    return [{
        field: 'id',
        label: 'ID',
        type: 'number',
        width: 30,
        hidden: true
      },
      {
        field: 'objectid',
        label: 'objectid',
        type: 'number',
        width: 50,
        hidden: true
      },      
      {
        field: 'categoria_fe',
        label: 'Cartografia',
        width: "15%",
      },
      {
        field: 'denominazione',
        label: 'Dato',
        width: "40%",
      },
      {
        field: 'datapub',
        label: 'Pubblicato o aggiornato',
        width: 50,
        type: 'date',
        dateInputFormat: 'dd/MM/yyyy',
        dateOutputFormat: 'dd/MM/yyyy'
      },
      {
        field: 'chiave_layer',
        label: 'Dato',
        width: 100,
        hidden: true,
      },
      {
        field: 'metadato',
        label: 'metadato',
        width: 75,
        hidden: true,
      },
      {
        field: 'datatipo',
        label: 'datatipo',
        width: 75,
        hidden: true
      },
      {
        field: 'isnull_note',
        label: 'isnull_note',
        width: 75,
        hidden: true
      },
      {
        field: 'note',
        label: 'note',
        width: 75,
        hidden: true,
      },
      {
        field: 'htmlurl_note',
        label: 'Condizioni dello strato',
        html: true,
        hidden: false,
        sortable: false,
        width: "10%"
        //dataClass: 'center aligned'
        //formatFn: this.NoteFormatterScaricati
      },
      {
        field: 'isnull_metadato',
        label: 'isnull_metadato',
        width: 50,
        hidden: true,
      },
      {
        field: 'htmlurl_metadato',
        label: 'Metadato',
        html: true,
        hidden: false,
        sortable: false,
        width: "10%"
        // this.MetadatoFormatter
      },
      {
        field: this.formatSCTOutilAllRepert,
        label: 'Download',
        html: true,
        width: "15%",
      },
    ];
  }



}
